export default {
  paths:[
    '/campaign-settings/*',
    '/campaign-settings/*/*'
  ],
  region:'leftDrawer',//header|topA|topB|left|mainTop|mainBottom|right|bottomB|bottomA|footer
  preload:false,
  weight:3
}
